exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-24eca174]:export {\n  xrColorPrimary: #2362FB;\n}\n.section-head[data-v-24eca174] {\n  font-size: 12px;\n  color: #333;\n  margin: 10px 0;\n}\n.section-head__icon[data-v-24eca174] {\n    font-size: 12px;\n    color: #666;\n    margin-right: 3px;\n}\n", ""]);

// exports
